import { Fragment as _Fragment, jsx as _jsx } from "preact/jsx-runtime";
const ErrorMessage = ({ errors, field }) => {
    if (!errors) {
        return (_jsx(_Fragment, {}, void 0));
    }
    const messages = errors[field];
    if (!messages) {
        return (_jsx(_Fragment, {}, void 0));
    }
    return (_jsx("p", Object.assign({ class: "help is-danger" }, { children: messages[0] }), void 0));
};
export default ErrorMessage;
